import { SessionData } from "types";
import {ENTITY_KEY} from "constants/globals";

export const setSession = (data: SessionData) => {
  if (typeof window !== "undefined") {
    return localStorage.setItem("session", JSON.stringify(data));
  }
  return null;
};

export const getSession = (): SessionData | null => {
  if (typeof window !== "undefined") {
    const session = localStorage.getItem("session");
    if (session) {
      return JSON.parse(session) as SessionData;
    }
  }
  return null;
};

export const getEntity = () => {
  //sbi specific
  if (typeof window !== "undefined") {
    const entity = localStorage.getItem(ENTITY_KEY);
    if (entity) {
      return entity;
    }
  }
  return null;
};

export const removeSession = () => {
  localStorage.removeItem("session");
  localStorage.removeItem("entity");
};
